// Rótulos normativos da ficha `inspection-v1` (form §7.3).
// Namespace `inspection.catalog.v1.*` — cada versão tem o próprio subtree.

export const inspectionCatalogV1EsES = {
  common: {
    yes: "Sí",
    no: "No",
    na: "N/A",
    notApplicable: "No aplica",
    good: "Bueno",
    regular: "Regular",
    deficient: "Deficiente",
    observations: "Observaciones",
    photos: "Fotos",
    others: "Otros (identificar)",
    describe: "Describir",
    local: "Local",
    note: "Nota",
    type: "Tipo",
    value: "Valor",
    flowRate: "Caudal",
    elevationM: "Elev. (m)",
    lengthM: "Longitud (m)",
    openingMm: "Abertura (mm)",
    orientation: "Orientación",
    manifestation: "Manifestación",
    solidCarryover: "Arrastre visible de sólidos",
    cleaningState: "Estado de limpieza",
    structuralCondition: "Condición estructural",
    structuralConditions: "Condiciones estructurales",
    addCrack: "Agregar grieta",
    addSettlement: "Agregar asiento / recalque",
    addSeepage: "Agregar surgencia / filtración",
    addErosion: "Agregar erosión",
    addLine: "Agregar línea",
    addOccurrence: "Agregar ocurrencia",
  },
  choices: {
    longitudinal: "Longitudinal",
    transversal: "Transversal",
    crest: "Coronación",
    berms: "Bermas",
    slopes: "Taludes",
    depression: "Depresión / Abatimiento",
    settlement: "Asiento / Recalque",
    grassNeedsPruning: "Gramínea que requiere siega",
    controlledOrAbsentDuringRaising: "Controlado / Ausente en alteamiento",
    shrubOrTreeVegetation: "Arbustiva y/o arbórea",
    absentWithoutRaising: "Ausente sin alteamiento",
  },
  placeholders: {
    local: "tramo, coordenada, estaca…",
    othersDescribe: "Identifique el hallazgo residual…",
    othersObservations: "Observaciones complementarias…",
    lengthExample: "Ej.: 3,20",
    openingExample: "Ej.: 5",
    flowValue: "Valor y unidad (ej.: 0,5 L/s)",
    elevation: "Elevación (m)…",
    beachLength: "Ej.: 15,00 m…",
    flowRate: "Caudal:…",
  },
  steps: {
    generalData: "Datos generales",
    accesses: "Situación de los accesos",
    damBody: "Espaldón / Estribos",
    reservoir: "Embalse",
    spillway: "Aliviadero(s) / Vertedero(s)",
    instrumentation: "Instrumentación (integridad física, identificación, acceso)",
    beachCondition: "Condición de playa",
    tailingsWaterIntake: "Tuberías de relaves / Captación de agua",
    conservationState: "Estado de conservación",
    generalComments: "Comentarios generales",
    signatures: "Firmas",
  },
  stepShort: {
    accesses: "Accesos",
    damBody: "Espaldón",
    reservoir: "Embalse",
    spillway: "Aliviadero",
    instrumentation: "Instrumentación",
    beachCondition: "Condición de playa",
    tailingsWaterIntake: "Tuberías / Captación",
  },
  sections: {
    pests: "Presencia de insectos / animales",
    internalDrainage: "Drenaje interno",
    geomembraneOccurrences: "Ocurrencias de geomembrana",
  },
  occurrence: {
    crack: "Grieta",
    settlement: "Asiento / Recalque",
    seepage: "Surgencia / Filtración",
    erosion: "Erosión",
    geomembrane: "Geomembrana",
  },
  items: {
    accesses: {
      generalConservation: "Conservación general",
      slopes: "Taludes",
      floorPavement: "Revestimiento del piso",
      drainageDevices: "Dispositivos de drenaje",
    },
    damBody: {
      cracksIdentified: "Grietas identificadas",
      settlementsIdentified: "Asientos / Recalques identificados",
      seepagesIdentified: "Surgencia(s) / filtración(es) de agua identificada(s)",
      surfaceErosions: "Erosiones superficiales",
      surfaceDrainage: "Drenaje superficial",
      drainageChannel: "Canal de drenaje",
      vegetalCover: "Revestimiento vegetal",
      pests: {
        termitesRodents: "Hormigueros / Termitas / Roedores",
        animals: "Animales (verificar huellas / heces)",
        burrows: "Presencia de madrigueras o agujeros",
      },
      internalDrainage: {
        outletSilting: "Asolvamiento de la salida del dren/coloide",
        solidCarryover: "Arrastre visible de sólidos",
        flowChange: "Alteración significativa del caudal",
        drainSaturation: "Saturación alrededor del dren",
        flowMeterOperational: "Caudalímetro operativo",
        flowMeasured: "Caudal del drenaje interno aforado en la inspección",
      },
      complementaryStructures: "Estructuras complementarias",
      reinforcement:
        "Estructura de refuerzo (contrarresto, berma de equilibrio, etc.)",
      saddleDike: "Dique de silla",
      sump: "Sump asociado a la estructura",
    },
    reservoir: {
      bankCondition:
        "Condición de las márgenes (erosiones o procesos de inestabilización)",
      impermeabilized: "Embalse impermeabilizado",
      geomembraneConservation: "Estado de conservación de la geomembrana",
      operationalFreeboard: "Bordo libre operacional",
    },
    spillway: {
      type: "Tipo de aliviadero / vertedero",
      inletSectionCondition: "Condición de la sección de embocadura",
      outletSectionCondition: "Condición de la sección de desagüe",
      stillingBasinCondition: "Condición de la cubeta de disipación",
      structuralCondition: "Condición estructural",
      hasEmergencySpillway: "¿Posee aliviadero de emergencia?",
    },
    instrumentation: {
      access: "Acceso a los instrumentos",
      protection: "Protección de los instrumentos",
      conservationState: "Estado de conservación",
      localGaugesCondition:
        "Condición de los aforadores locales (regla, graduación pluviométrica, cubos, cinta con sensor sónico)",
      identification: "Identificación de los instrumentos",
    },
    beachCondition: {
      tailingsDisposal: "Disposición/manejo de relaves en el embalse",
      safeWaterDistance:
        "Distancia segura de la lámina de agua respecto a la coronación",
      physicalSignaling: "Condición operativa de la señalización física (tambores)",
      beachLengthVsCrest:
        "Longitud de la condición de playa respecto a la coronación (si aplica)",
    },
    tailingsWaterIntake: {
      tailingsInflow: "¿Hay aporte de relaves al embalse?",
      tailingsLineLeak: "¿La línea de relaves presenta signos de fuga?",
      waterPumpingActive:
        "¿Hay bombeo de agua del embalse? Indicar si está activo",
      waterPipeLeak: "¿La tubería de agua presenta signos de fuga?",
      intakeOperating: "¿El sistema de captación opera con normalidad? Caudal:",
      bargeAccessOperating:
        "¿El acceso al sistema de captación «balsa» está operando?",
    },
  },
} as const;
